import {createSvgIcon} from '../create-svg-icon';

export const BrandingWatermarkIcon = createSvgIcon(
  <path d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zm-10-7h9v6h-9z" />
, 'BrandingWatermarkOutlined');
